import axiosInstance from "../axiosInstance";

const CONTROLLER = "activeIngredients";

const get_active_ingredients = async (search) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}?search=${search || ""}`
	);
	return response.data;
};

const get_active_ingredients_page = async (search, state, page) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetPage?search=${
			search || ""
		}&state=${state}&pageNumber=${page}`
	);
	return response.data;
};

const get_active_ingredient_by_id = async (id) => {
	const response = await axiosInstance.get(`${CONTROLLER}/GetById/${id}`);
	return response.data;
};

const create_active_ingredient = async (activeIngredient) => {
	const response = await axiosInstance.post(`${CONTROLLER}`, activeIngredient);
	return response.data;
};

const update_active_ingredient = async (id, activeIngredient) => {
	const response = await axiosInstance.put(
		`${CONTROLLER}/${id}`,
		activeIngredient
	);
	return response.data;
};

const get_active_ingredients_header_info = async (search) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetActiveIngredientsHeader`
	);
	return response.data;
};

const update_active_ingredient_state = async (id, state) => {
	const response = await axiosInstance.put(
		`${CONTROLLER}/UpdateActiveIngredientState/${id}`,
		state
	);
	return response.data;
};

const get_active_ingredients_name_list = async () => {
	const response = await axiosInstance.get(`${CONTROLLER}/GetNameList`);
	return response.data;
};

export {
	get_active_ingredients,
	get_active_ingredients_page,
	create_active_ingredient,
	get_active_ingredient_by_id,
	update_active_ingredient,
	get_active_ingredients_header_info,
	update_active_ingredient_state,
	get_active_ingredients_name_list,
};
